// This is generated.  Alter it in blockGroups/formButtons/types/MenuButton.js
/* eslint-disable no-unused-vars */
const { actionUtils, config } = require('@sstdev/lib_metadata-config');
const { moduleRegistration } = require('@sstdev/lib_metadata-config');
module.exports = {
  asDataDictionary: function asDataDictionary(
    hNode,
    context = {},
    parentAccessRestrictions,
  ) {
    const accessRestrictions = actionUtils.getNodeAccessRestrictions(
      hNode,
      context,
      parentAccessRestrictions,
    );
    if (accessRestrictions.hidden) return [{}, {}];

    // Form MenuButton is a container for menu items within a form context
    // It doesn't define namespace/relation itself - it uses the parent form's context
    // The menu children may contain actions, but the button itself doesn't contribute schema properties
    return [{}, {}];
  },
};
moduleRegistration.registerHNodeType(
  'formButtons',
  'MenuButton',
  module.exports,
);
